<template>
  <div>
    <el-tabs
      v-model="currentTab"
      @tab-remove="removeTab"
      @tab-click="handleClick"
    >
      <el-tab-pane
        label="战略阶段计划"
        name="zljh"
        key="zljh"
      >
        <template v-if="currentTab === 'zljh'">
          <StrategicPlan/>
        </template>
      </el-tab-pane>
      <el-tab-pane
        label="预战术阶段计划"
        name="yzsjh"
        key="yzsjh"
      >
        <template v-if="currentTab === 'yzsjh'">
          <PreacticalPlan/>
        </template>
      </el-tab-pane>
      <el-tab-pane
        label="预战术阶段临时计划"
        name="zslsjh"
        key="zslsjh"
      >
        <template v-if="currentTab === 'zslsjh'">
          <PreacticalTemporaryPlan/>
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script type="text/javascript">
import StrategicPlan from "./plan/StrategicPlan.vue";
import PreacticalPlan from "./plan/PreacticalPlan.vue";
import PreacticalTemporaryPlan from "./plan/PreacticalTemporaryPlan.vue";

export default {
  name: "PlanApproval",
  props: {},
  data() {
    return {
      currentTab: 'zljh',
    }

  },
  watch: {},
  computed: {},
  components: {
    StrategicPlan,
    PreacticalPlan,
    PreacticalTemporaryPlan,
  },
  methods: {
    handleClick(tab) {
      this.currentTab = tab.name;
    },
    removeTab(targetName) {
      this.$emit("removeTab", targetName);
    },
  },
  mounted() {

  },
  beforeDestroy() {

  },
};
</script>
<style scoped>
>>> .el-tabs .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav .el-tabs__active-bar {
  display: none;
}

>>> .el-tabs .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav div {
  margin-top: 20px;
  height: 30px;
  margin-right: 14px;
  background: url(../../assets/img/admin/btn_normal.png) center no-repeat;
  background-size: 100% 100%;
  font-size: 20px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: center;
  color: #fff;
  text-shadow: -2px 0 1.84px 0.16px rgba(16, 1, 0, 0.50);
  line-height: 30px;
  padding-left: 11px;
  padding-right: 13px;
  -moz-user-select: none;
  /*火狐*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -ms-user-select: none;
  /*IE10*/
  -khtml-user-select: none;
  /*早期浏览器*/
  user-select: none;
}

>>> .el-tabs__nav-wrap::after {
  height: 0;
}

>>> .el-tabs .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav div:hover,
>>> .el-tabs .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav div.is-active {

  background: url(../../assets/img/admin/btn_click.png) center no-repeat;
  background-size: 100% 100%;
  font-size: 20px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: center;
  color: #00AEFF;
  text-shadow: -2px 0 1.84px 0.16px rgba(16, 1, 0, 0.50);

}

>>> .el-tab-pane > div:first-child {
  background: #010A12 !important;
}
</style>




// WEBPACK FOOTER //
// src/components/home/PlanApproval.vue